module.exports = __webpack_public_path__ + "static/img/2.e851d56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/2.png
// module id = UdLC
// module chunks = 0